"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validateModelTranslation = {
    fi: {
        validateModel: {
            title: 'Viimeistele tunnus',
            subTitle: 'Viimeistele tunnus antamalla kaikki tarvittavat tiedot',
            button: 'Tallenna',
        },
    },
    en: {
        validateModel: {
            title: 'Complete your account',
            subTitle: 'Complete missing information and click save',
            button: 'Save',
        },
    },
};
exports.default = validateModelTranslation;
//# sourceMappingURL=validate-model.translation.js.map